import { isNullOrUndefined } from '@bimser/core';
import DataGrid2 from '../../..';

type IDataGridColumnSortArgs = {
	columnName: string;
	sortOrder: string;
	sortIndex?: number;
};

export function sortColumn(this: DataGrid2, args: IDataGridColumnSortArgs) {
	const instance = this.__bcDataGridRef.current?.instance();

	if (instance) {
		instance.columnOption(args.columnName, 'sortOrder', args.sortOrder);

		if (!isNullOrUndefined(args.sortIndex)) {
			instance.columnOption(args.columnName, 'sortIndex', args.sortIndex);
		}
	}
}
